<template>
  <div class="fourth-screen">
    <div class="screen-title">
      <div>自研Agent框架  结合业务场景</div>
      <div>定制专属的AI员工</div>
<!--      <div class="play-box">
        <div class="box-icon">
          <img src="../../assets/image/play_red.svg" alt="">
        </div>
      </div>-->

      <div class="title-desc">
        <div>独自开自研的核心算法，为企业沉淀业务数据，深度学习业务</div>
        <div>知识，自动梳理业务流程，建设企业的业务架构与模型。</div>
      </div>
    </div>
    <div class="screen-inner">
      <el-carousel indicator-position="outside" height="420" v-if="bannerList && bannerList.length">
        <el-carousel-item v-for="(item, index) of bannerList" :key="index">
          <div class="item-image">
            <img :src="item.img_4_page_link_wc" alt="">
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="inner-video">
        <div class="video-item">
          <video width="288px" height="161px" style="border-radius: 12px;" controls src="https://global-application-001.downline.cn/www.duzikai.com/goods_image/ZKc3Ak1701759624302.mp4"></video>
        </div>
        <div class="video-item"></div>
        <div class="video-item"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import absoutApi from "@/api/about";
  import pageCommon from "@/utils/pagecommon";
  export default {
    data() {
      return {
        bannerList: []
      }
    },
    mounted() {
      // this.getBannerData()
    },
    methods: {

    }
  }
</script>

<style lang="less" scoped>
  .fourth-screen {
    color: #222222;
    width: 100%;
    height: 1209px;
    background: linear-gradient(0deg, #F3F5F9 0%, #FFFFFF 100%);
    padding-top: 99px;
    box-sizing: border-box;
    .screen-title {
      font-size: 56px;
      font-weight: 600;
      position: relative;
      letter-spacing: 4px;
      .play-box {
        width: 72px;
        height: 72px;
        background-color: #fff;
        box-shadow: 0px 4px 38px 0px rgba(199,203,211,0.39);
        border-radius: 17px;
        position: absolute;
        right: 26px;
        top: 0;
        cursor: pointer;
        transition: all 1.5s;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        .box-text {
          text-align: left;
          margin-right: 14px;
          font-size: 14px;
          color: #222;
          .text-desc {
            font-size: 12px;
            color: #666666;
            margin-top: 8px;
          }
        }
        .box-icon {
          width: 44px;
          height: 44px;
        }
        &:hover {
          .box-icon {
            transform: scale(1.2);
          }
        }
      }
      .title-desc {
        font-size: 20px;
        color: #666666;
        margin-top: 46px;
        font-weight: normal;
        letter-spacing: normal;
      }
    }
    .screen-inner {
      max-width: 1200px;
      margin: 88px auto 56px;
      .item-image {
        width: 100%;
        height: 420px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .inner-video {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .video-item {
          width: 360px;
          height: 202px;
          border-radius: 24px;
        }
      }
    }
  }
</style>

<style lang="less">
  .el-carousel__container {
    height: 420px !important;
  }
  .el-carousel__button {
    width: 6px !important;
    height: 6px !important;
    background-color: rgba(102, 102, 102, .3) !important;
    border-radius: 50%;
  }
  .el-carousel__indicators {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 28px 0 56px;
    .el-carousel__indicator {
      padding: 28px 5px 56px !important;
    }
  }
  .el-carousel__indicator.is-active {
    .el-carousel__button {
      width: 10px !important;
      height: 10px !important;
      background-color: rgba(44, 108, 230, 1) !important;
    }

  }
</style>